import React from 'react';
import { zones } from '../data/zones';
import { company } from '../data/company';
import { SectionHeading } from './SectionHeading';
export function Zones() {
  return <section id="zones" className="bg-ink-900 py-16 text-bone lg:py-24" data-id="element-225" data-mp="1h8ckws4ic7d4">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-226" data-mp="13cqx2oa0ftma">
        <SectionHeading title="Où j’interviens, et en combien de temps" tone="dark" intro={`Départ de ${company.address}, ${company.postalCode} ${company.city}. Les délais ci-dessous sont ceux constatés en conditions normales de circulation.`} data-id="element-227" data-mp="17brdk050mk64" />

        <div className="mt-12 grid gap-px bg-ink-700 sm:grid-cols-3" data-id="element-228" data-mp="1mabmpxklmw7y">
          {zones.map(zone => <div key={zone.name} className="flex flex-col bg-ink-900 p-6 lg:p-8" data-id="element-229" data-mp="1qavgcr5yrhpc">
              <p className="font-display text-3xl font-extrabold text-brass-light lg:text-4xl" data-id="element-230" data-mp="2e17zky6nt0v8">
                {zone.delay}
              </p>
              <h3 className="mt-3 font-display text-base font-bold text-bone" data-id="element-231" data-mp="2ishmhr0tpq3f">{zone.name}</h3>
              <ul className="mt-4 space-y-1.5 border-t border-ink-700 pt-4 text-sm text-ink-500" data-id="element-232" data-mp="3seybbsfdyqda">
                {zone.towns.map(town => <li key={town} data-id="element-233" data-mp="3nd8yq8cim4n3">{town}</li>)}
              </ul>
            </div>)}
        </div>

        <p className="mt-8 text-sm text-ink-500" data-id="element-234" data-mp="17dexeuwqvj0">
          Votre commune n’est pas listée&nbsp;? Appelez-moi, je vous dis honnêtement si je peux être
          là rapidement ou non.
        </p>
      </div>
    </section>;
}